import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { forkJoin, map, switchMap } from 'rxjs';

import { TvoedLabourAgreement } from '../../models/tvoed-labour-agreement.model';
import { TvoedData, TvoedSubTableData } from '../../models/tvoed-data.model';
import { TvoedExtraPaymentDefinition } from '../../models/tvoed-extra-payment.model';

@Injectable({
  providedIn: 'root'
})
export class TvoedSalaryService {
  private http = inject(HttpClient);

  getLabourAgreements() {
    return this.http.get<TvoedLabourAgreement[]>(`assets/tvoed-salary-calculator/labour-agreements.json`);
  }

  getTvoedData(year: number) {
    return this.http.get<TvoedData>(`assets/tvoed-salary-calculator/${year}/era-data.json`);
  }

  getExtraPayments(year: number) {
    return this.http.get<TvoedExtraPaymentDefinition[]>(`assets/tvoed-salary-calculator/${year}/extra-payments.json`);
  }

  getSubTables(year: number) {
    return this.getTvoedData(year).pipe(
      map(tvoedData => {
        return Object.entries(tvoedData).map(([key, st]: [string, TvoedSubTableData]) => ({ key, name: st.name }));
      })
    );
  }

  getSubTable(year: number, subTable: string) {
    return this.getTvoedData(year).pipe(
      map((tvoedData: TvoedData) => {
        return tvoedData[subTable];
      })
    );
  }

  getAllLabourAgreementsData() {
    return this.getLabourAgreements().pipe(
      switchMap((labourAgreements: TvoedLabourAgreement[]) => {
        const years = labourAgreements.map((la: TvoedLabourAgreement) => la.tvoed);
        const subsequentTvoedDataRequests = years.map((year: number) =>
          this.getTvoedData(year).pipe(
            map((tvoedData: TvoedData) => ({
              labourAgreement: labourAgreements.find((la: TvoedLabourAgreement) => la.tvoed === year),
              tvoedData
            }))
          )
        );
        return forkJoin(subsequentTvoedDataRequests);
      })
    );
  }
}
